import React, { useEffect, useState } from "react";
import SearchBar from "../Main/searchBar";
import { Table, Badge } from "antd";
import { ReactComponent as BackIcon } from "../../Assets/Categories/BackIcon.svg";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { viewCountryList } from "../../Redux/Actions/settingsActions";
import { useParams } from "react-router-dom";
import { ReactComponent as CountryCode } from "./Country Icon/Country Code.svg";
import { ReactComponent as CountryLanguage } from "./Country Icon/Country Language.svg";
import { ReactComponent as LanguageCode } from "./Country Icon/Language Code.svg";
import { ReactComponent as CurrencyIcon } from "./Country Icon/Currency.svg";
import { ReactComponent as CurrencySymbol } from "./Country Icon/Currency Symbol.svg";

const ViewCountry = () => {
  const [countryData, setCountryData] = useState({});
  const { id } = useParams();
  const [searchQuery, setSearchQuery] = useState("");

  const dispatch = useDispatch();

  const { countryList } = useSelector((state) => state.country);

  useEffect(() => {
    dispatch(viewCountryList(1, 10));
  }, [dispatch]);

  useEffect(() => {
    if (countryList?.data) {
      const foundCountry = countryList.data.find(
        (country) => country._id === id
      );
      setCountryData(foundCountry || {});
    }
  }, [countryList, id]);

  const filteredCountries = countryList?.data?.filter((country) =>
    country.country_name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const columns = [
    {
      title: "Country Name",
      dataIndex: "country_name",
      key: "country_name_withoutspace",
      align: "center",
    },
    {
      title: "Country Code",
      dataIndex: "country_code",
      key: "country_code",
      align: "center",
    },
    {
      title: "Country's Language",
      dataIndex: "country_language_name",
      key: "country_language_name",
      align: "center",
    },
    {
      title: "Language Code",
      dataIndex: "country_language_code",
      key: "country_language_code",
      align: "center",
    },
    {
      title: "Country's Currency",
      dataIndex: "country_currency",
      key: "country_currency",
      align: "center",
    },
    {
      title: "Currency's Symbol",
      dataIndex: "country_currency_symbol",
      key: "country_currency_symbol",
      align: "center",
    },
    {
      title: "Status",
      dataIndex: "status",
      align: "center",
      key: "status",
      render: (status) => (
        <span
          style={{
            display: "inline-flex",
            alignItems: "center",
            padding: "4px 8px",
            border: "1px solid #d9d9d9", // Light gray border
            borderRadius: "10px", // Rounded edges
          }}
        >
          <Badge
            color={status === "active" ? "green" : "red"}
            text={status}
            background
          ></Badge>
        </span>
      ),
    },
  ];

  return (
    <div>
      <div style={{ marginTop: "10px", marginRight: "10px", width: "100%" }}>
        <div>
          <SearchBar></SearchBar>
        </div>
        <div
          style={{
            display: "flex",

            alignItems: "flex-start",
            textAlign: "center",
            marginLeft: "20px",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <Link to="/country">
              <BackIcon style={{ cursor: "pointer" }} />
            </Link>
            <div
              style={{
                flexDirection: "column",
                alignItems: "center",
                display: "flex",
                gap: "20px",

              }}
            >
              <h1>{countryData?.country_name || "No Country Found"}</h1>
              <h4
                style={{
                  position: "absolute",
                  top: "115px",
                  fontFamily: "Gilroy-Medium",
                  fontSize: "14px",
                  fontStyle: "normal",
                  fontWeight: "100",
                  lineHeight: "10px",
                  left: "95px",
                }}
              >
                Country/ List/ View
              </h4>
            </div>
          </div>
        </div>
      </div>

      <div
        style={{
          marginTop: "20px",
          display: "flex",
          gap: "20px",
          alignItems: "flex-start",
          width: "100%",
        }}
      >
        <div
          style={{
            marginLeft: "2vh",
            display: "inline-block",
            width: "40%",
            minHeight: "100vh",
            background:
              "radial-gradient(4751.52% 100% at 100% 50%, #0D152B 28.65%, rgba(13, 21, 43, 0.70) 100%)",
            borderRadius: "30px",
            flexDirection: "column",
            alignItems: "flex-start",
            position: "relative",
          }}
        >
          <div
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div style={{ marginLeft: "2rem", paddingTop: "1vh" }}>
              <span
                style={{
                  color: "#999",
                  position: "relative",
                  top: "1rem",
                  fontSize: "14px",
                }}
              >
                Country Code
              </span>
              <h2
                style={{
                  color: "white",
                }}
              >
                <strong>
                  {countryData ? countryData.country_name : "No Name Found"}
                </strong>
              </h2>
            </div>
            <Link to={`/country/edit/${id}`}>
              <button
                style={{
                  padding: "12px 24px",
                  marginRight: "2vw",
                  background:
                    "radial-gradient(4751.52% 100% at 100% 50%, #0D152B 28.65%, rgba(13, 21, 43, 0.70) 100%)",
                  border: "1px solid white",
                  borderRadius: "5px",
                  cursor: "pointer",
                  color: "white",
                  fontFamily: "Gilroy-Bold",
                  fontSize: "14px",
                  fontStyle: "normal",
                  fontWeight: "400",
                  lineHeight: "14.6px",
                }}
              >
                Edit
              </button>
            </Link>
          </div>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <div
              style={{
                marginLeft: "2rem",
                display: "flex",

                alignItems: "center",
                gap: ".5vw",
              }}
            >
              <CountryCode></CountryCode>
              <div>
                <span
                  style={{
                    color: "#999",
                    position: "relative",
                    top: "1rem",
                    fontSize: "14px",
                  }}
                >
                  Country Code
                </span>
                <h4 style={{ color: "white", fontSize: "20px" }}>
                  {countryData ? countryData.country_code : "No Data Found"}
                </h4>
              </div>
            </div>
            <div
              style={{
                marginLeft: "2rem",
                display: "flex",
                alignItems: "center",
                gap: ".5vw",
              }}
            >
              <CountryLanguage></CountryLanguage>
              <div>
                <span
                  style={{
                    color: "#999",
                    position: "relative",
                    top: "1rem",
                    fontSize: "14px",
                  }}
                >
                  National Language
                </span>
                <h4 style={{ color: "white", fontSize: "20px" }}>
                  {countryData
                    ? countryData.country_language_name
                    : "No Data Found"}
                </h4>
              </div>
            </div>
            <div
              style={{
                marginLeft: "2rem",
                display: "flex",
                alignItems: "center",
                gap: ".5vw",
              }}
            >
              <LanguageCode></LanguageCode>
              <div>
                <span
                  style={{
                    color: "#999",
                    position: "relative",
                    top: "1rem",
                    fontSize: "14px",
                  }}
                >
                  Language Code
                </span>
                <h4 style={{ color: "white", fontSize: "20px" }}>
                  {countryData
                    ? countryData.country_language_code
                    : "No Data Found"}
                </h4>
              </div>
            </div>
            <div
              style={{
                marginLeft: "2rem",
                display: "flex",
                alignItems: "center",
                gap: ".5vw",
              }}
            >
              <CurrencyIcon></CurrencyIcon>
              <div>
                <span
                  style={{
                    color: "#999",
                    position: "relative",
                    top: "1rem",
                    fontSize: "14px",
                  }}
                >
                  National Currency
                </span>
                <h4 style={{ color: "white", fontSize: "20px" }}>
                  {countryData ? countryData.country_currency : "No Data Found"}
                </h4>
              </div>
            </div>
            <div
              style={{
                marginLeft: "2rem",
                display: "flex",
                alignItems: "center",
                gap: ".5vw",
              }}
            >
              <CurrencySymbol></CurrencySymbol>
              <div>
                <span
                  style={{
                    color: "#999",
                    position: "relative",
                    top: "1.5rem",
                    fontSize: "14px",
                  }}
                >
                  Curreny Symbol
                </span>
                <h4 style={{ color: "white", fontSize: "20px" }}>
                  {countryData
                    ? countryData.country_currency_symbol
                    : "No Data Found"}
                </h4>
              </div>
            </div>
          </div>
        </div>
        <span
          style={{ width: "100%", background: "white", borderRadius: "25px" }}
        >
          <div
            style={{
              marginLeft: "2vh",
              paddingTop: "30px",
              display: "flex",
              gap: "5%",
              alignItems: "center",
            }}
          >
            <h1>Country List</h1>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                border: "1px solid #ccc", // Border around the search bar
                borderRadius: "25px",
                padding: "5px 15px",
                width: "110vh", // Set the width of the search bar
                transition: "border-color 0.3s ease, box-shadow 0.3s ease",
              }}
            >
              <input
                type="text"
                placeholder="Search"
                onChange={(e) => setSearchQuery(e.target.value)}
                style={{
                  padding: "10px",
                  width: "100vh",
                  borderRadius: "25px",
                  border: ".01px solid #ccc",
                  fontSize: "16px",
                  // marginRight: "20vh", // Space between search bar and button
                  outline: "none", // Remove default focus outline
                  transition: "border-color 0.3s ease, box-shadow 0.3s ease", // Smooth transition for focus effect
                }}
                onFocus={(e) => {
                  e.target.style.border = ".01px solid #172358"; // Highlight border color on focus
                  e.target.style.boxShadow = "0 0 10px rgba(23, 35, 88, 0.5)"; // Light shadow effect
                }}
                onBlur={(e) => {
                  e.target.style.border = ".01px solid #ccc"; // Reset border when focus is lost
                  e.target.style.boxShadow = "none"; // Reset shadow effect
                }}
              />
            </div>
          </div>
          <div style={{ padding: "0px 60px" }}>
            <Table
              columns={columns}
              //   dataSource={category ? [category] : []}
              dataSource={filteredCountries}
              rowKey="_id"
              pagination={{ pageSize: 15 }}
              style={{ flex: 1, width: "100%" }}
            />
          </div>
        </span>
      </div>
    </div>
  );
};

export default ViewCountry;
